import { render } from "./StatuspagegroupsDetails.vue?vue&type=template&id=71846d9e&scoped=true"
import script from "./StatuspagegroupsDetails.vue?vue&type=script&lang=js"
export * from "./StatuspagegroupsDetails.vue?vue&type=script&lang=js"

import "./StatuspagegroupsDetails.vue?vue&type=style&index=0&id=71846d9e&scoped=true&lang=css"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71846d9e"]])

export default __exports__